<template>
  <div class='InputSearch'>
    <input @input="run" :placeholder="placeholder" type="text">
    <div class="cont-icon-search">
      <search-icon v-if="!load"/>
      <div class="cont-load" v-if="load">
        <vue-spinner size="20"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SearchIcon from '../Icons/SearchIcon'
import { VueSpinner } from 'vue3-spinners'
export default {
  name: 'InputSearch',
  components: { SearchIcon, VueSpinner },
  data () {
    return {
      timeout: null,
      load: false
    }
  },
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    action: {
      type: String,
      default: ''
    },
    tam: {
      type: String,
      default: '30%'
    }
  },
  methods: {
    ...mapActions(['SearchNameProdPainel', 'SearchClientPainel', 'SearchPedidoPainel', 'SearchUserPainel', 'SearchGiftPainel']),
    run (e) {
      if(this.timeout !== null) {
        clearTimeout(this.timeout)
      }
      this.load = true
      this.timeout = setTimeout(() => {
        this[this.action](e.target.value)
          .then(() => this.load = false)
      }, 800)
    }
  }
}
</script>

<style scoped>
.InputSearch {
  width: 30%;
  display: flex;
  align-items: center;
  /* background-color: #EEEEEE; */
  border: thin solid #CCCCCC;
  border-radius: 5px;
}

input {
  width: 90%;
  border: 0;
  font-size: 18px;
  padding: 2%;
}

input:focus {
  outline: none;
}

.cont-icon-search {
  width: 10%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-left: thin solid #CCCCCC;
}
.cont-load {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 38px;
}

@media (max-width: 500px) {
  .InputSearch {
    width: 70%;
    justify-content: end;
  }
}
</style>
